<template>
  <header :class="['nav', { 'nav--scrolled': scrolled }]">
    <div class="container nav__inner">
      <router-link to="/" class="brand">
        <img class="brand__logo" :src="require('@/assets/logo-mark.png')" alt="三剑客房产" />
        <span class="brand__text">
          <strong>三剑客房产</strong>
          <small>SANJIANKE · 嘉兴</small>
        </span>
      </router-link>

      <nav :class="['nav__links', { open: menuOpen }]" @click="menuOpen = false">
        <router-link to="/">首页</router-link>
        <router-link to="/properties">房源中心</router-link>
        <router-link to="/services">服务与咨询</router-link>
        <router-link to="/about">关于我们</router-link>
      </nav>

      <div class="nav__actions">
        <router-link to="/login" class="nav__login">会员登录</router-link>
        <router-link to="/register" class="btn btn--primary">免费注册</router-link>
        <button class="nav__toggle" @click="menuOpen = !menuOpen" aria-label="菜单">
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheNavbar',
  data() {
    return { scrolled: false, menuOpen: false }
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 20
    },
  },
}
</script>

<style scoped>
.nav {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, .96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid transparent;
  transition: box-shadow .25s ease, border-color .25s ease;
}
.nav--scrolled {
  box-shadow: 0 6px 22px rgba(18, 57, 91, .08);
  border-color: var(--line);
}
.nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}
.brand { display: flex; align-items: center; gap: 12px; }
.brand__logo { height: 46px; width: auto; display: block; }
.brand__text { display: flex; flex-direction: column; line-height: 1.15; }
.brand__text strong { color: var(--brand); font-size: 18px; }
.brand__text small { color: var(--muted); font-size: 11px; letter-spacing: 1px; }

.nav__links { display: flex; gap: 30px; }
.nav__links a {
  font-weight: 600;
  color: var(--ink);
  padding: 6px 0;
  position: relative;
}
.nav__links a.router-link-active::after {
  content: '';
  position: absolute; left: 0; right: 0; bottom: -4px;
  height: 3px; border-radius: 3px;
  background: var(--accent);
}
.nav__links a:hover { color: var(--brand-2); }

.nav__actions { display: flex; align-items: center; gap: 16px; }
.nav__login { font-weight: 600; color: var(--brand); }
.nav__login:hover { color: var(--brand-2); }

.nav__toggle { display: none; flex-direction: column; gap: 5px; background: none; border: none; cursor: pointer; padding: 6px; }
.nav__toggle span { width: 24px; height: 2px; background: var(--brand); border-radius: 2px; }

@media (max-width: 860px) {
  .nav__links {
    position: absolute; top: 72px; left: 0; right: 0;
    flex-direction: column; gap: 0;
    background: #fff;
    border-bottom: 1px solid var(--line);
    max-height: 0; overflow: hidden;
    transition: max-height .28s ease;
  }
  .nav__links.open { max-height: 320px; }
  .nav__links a { padding: 15px 24px; border-top: 1px solid var(--line); }
  .nav__links a.router-link-active::after { display: none; }
  .nav__login { display: none; }
  .nav__toggle { display: flex; }
}
</style>
